import unifiedExperienceScenario from './unified-experience';

let options = {
  createBilling: true,
};

export default function (server) {
  unifiedExperienceScenario(server, { ...options, projectCount: 15 });
}
